import api from "./api"

export const fnShowTutorial = async () => {
    const response = await api.get(`/op-panel/board-models/user_tutorial`)
    return response
}
export const fnUpdateShowTutorial = async () => {
    const response = await api.patch(`/op-panel/board-models/user_tutorial`)
    return response
}